import { useState } from 'react';
import { AMZEDEL_LOGO_URL, NOMBRE_FARMACIA } from '@/lib/marca';

interface MarcaLogoProps {
  /** Clases de tamaño únicamente (w-… h-…) */
  boxClassName?: string;
  iconClassName?: string;
  imgClassName?: string;
}

/**
 * Muestra el logo real de AMZEDEL sobre una placa clara.
 * Si la imagen no está disponible, cae al ícono de respaldo para no romper el diseño.
 */
export default function MarcaLogo({
  boxClassName = 'w-10 h-10',
  iconClassName = 'ri-medicine-bottle-line text-xl text-white',
  imgClassName = 'w-full h-full object-contain',
}: MarcaLogoProps) {
  const [failed, setFailed] = useState(false);

  if (AMZEDEL_LOGO_URL && !failed) {
    return (
      <div
        className={`${boxClassName} rounded-lg bg-white border border-background-200 flex items-center justify-center flex-shrink-0 p-1`}
      >
        <img
          src={AMZEDEL_LOGO_URL}
          alt={NOMBRE_FARMACIA}
          className={imgClassName}
          onError={() => setFailed(true)}
        />
      </div>
    );
  }

  return (
    <div className={`${boxClassName} rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0`}>
      <i className={iconClassName}></i>
    </div>
  );
}